import * as ACTION from '../../Redux.constants';
import {setDesignTab} from './SetDesignTab';

export function DesignReducer(state, action) {
  switch (action.type) {
    case ACTION.DESIGN_SET_TAB:
      return setDesignTab(state, action.payload);
    default:
      return state;
  }
}
